import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('modal', ['openModal']),
    removeComma(value) {
      if (!value) return '';
      value = value.toString();
      return value.replace(/\D/g, '');
    },
    addComma(value) {
      value = this.removeComma(value);
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0';
    },
  },
};
